import { useCallback } from "react";
import { useSignalR } from "./useSignalR";
import { useSignalRConnections } from "../context/SignalRProvider";

interface SettingChangedData {
    updatedBy: string;
    settingName: string;
}

export function useSettingsHub(onSettingsChanged?: (data: SettingChangedData) => void) {
    const { notificationConnection } = useSignalRConnections();

    // Handle incoming setting-changed messages
    const memoizedHandler = useCallback(
        (data: SettingChangedData) => {
            onSettingsChanged?.(data);
        },
        [onSettingsChanged]
    );

    // Listen for SystemSettingChanged from server
    useSignalR(notificationConnection, "SystemSettingChanged", memoizedHandler);

    // Broadcast setting change to others
    const sendSettingChanged = useCallback(
        async (updatedBy: string, settingName: string) => {
            if (!notificationConnection) {
                return;
            }
            await notificationConnection.invoke("NotifySettingsChanged", updatedBy, settingName);
        },
        [notificationConnection]
    );

    return { sendSettingChanged };
}
